import { render, staticRenderFns } from "./FactorList.vue?vue&type=template&id=63712407&scoped=true&"
import script from "./FactorList.vue?vue&type=script&lang=js&"
export * from "./FactorList.vue?vue&type=script&lang=js&"
import style0 from "./FactorList.vue?vue&type=style&index=0&id=63712407&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63712407",
  null
  
)

export default component.exports